import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    // Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    Pagination
} from "reactstrap";
import Breadcrumb from "../../../layout/breadcrumb";
import { useForm } from "react-hook-form";
import Axios from "axios";
import { toast } from "react-toastify";
import Dropzone from 'react-dropzone-uploader';
import { downloadReconciliationReport, generateReconcileReport, getReconcileReportLogs } from "../../../api";
import moment from "moment";
import { MaterialReactTable } from "material-react-table";
import {
    Chip, Button, Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";


const ReconcileReport = () => {
    const { register, watch, handleSubmit, setValue, getValues, formState, reset, trigger, errors } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [taxillaReportFile, settaxillaReportFile] = useState('');
    const [bcReportFile, setBCReportFile] = useState('');
    const [uploadFlags, setUploadFlags] = useState({
        taxilla: false,
        bc: false,
    });
    const [reportList, setReportList] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [totalPages, setTotalPages] = useState(0);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const formatStatus = (status) =>
        status
            .split("_")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

    const columns = [
        {
            accessorKey: "sr",
            header: "#",
            size: 50,
            Cell: ({ row }) => row.index + 1,
        },
        {
            accessorKey: "start_Date",
            header: "Start Date",
            Cell: ({ cell }) =>
                moment(cell.getValue()).format("YYYY-MM-DD"),
        },
        {
            accessorKey: "end_Date",
            header: "End Date",
            Cell: ({ cell }) =>
                moment(cell.getValue()).format("YYYY-MM-DD"),
        },
        {
            header: "Taxilla Report",
            enableSorting: false,
            Cell: ({ row }) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => handleDownload(row.original.taxilla_report)}
                ><i className="fa fa-download"></i>
                    {/* {"Taxilla"} */}
                </Button>
            ),
        },
        {
            header: "BC Report",
            enableSorting: false,
            Cell: ({ row }) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => handleDownload(row.original.bc_report)}
                >
                    <i className="fa fa-download"></i>

                    {/* {"BC"} */}
                </Button>
            ),
        },
        {
            accessorKey: "user.name",
            header: "Generated By",
        },
        {
            accessorKey: "created_at",
            header: "Generated Date",
            Cell: ({ cell }) =>
                moment(cell.getValue()).format("YYYY-MM-DD"),
        },
        {
            accessorKey: "status",
            header: "Status",

            filterVariant: "select",
            filterSelectOptions: [
                { text: "Generated", value: "generated" },
                { text: "In Process", value: "in_process" },
                { text: "Failed", value: "failed" },
            ],

            Cell: ({ cell }) => {
                const status = cell.getValue();
                return (
                    <Chip
                        label={formatStatus(status)}
                        color={
                            status === "generated"
                                ? "success"
                                : status === "in_process"
                                    ? "warning"
                                    : "error"
                        }
                        size="small"
                    />
                );
            },
        },
        {
            header: "Reconcile Report",
            enableSorting: false,
            Cell: ({ row }) => (
                <Button
                    size="small"
                    variant="contained"
                    disabled={
                        row.original.status !== "generated" ||
                        !row.original.reconcile_report
                    }
                    onClick={() =>
                        // handleDownload(row.original.reconcile_report)
                        downloadReport(row.original.reconcile_report_id)
                    }
                >   <i className="fa fa-download"></i>
                    {"Download"}
                </Button>
            ),
        },
    ];



    const getLastDayOfMonth = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth() + 1, 0)
            .toISOString()
            .split('T')[0];
    };

    const handletaxillaReportFile = ({ meta, file }, status) => {
        if (status === 'done') {
            const formData = new FormData()
            formData.append('profile', file)
            Axios.put(`${process.env.REACT_APP_SERVER_URL}/api/users/uploadImage`, formData, {
            }).then(async (res) => {
                const response = res.data.msg;
                console.log("taxilla-response", response);
                settaxillaReportFile(response)
                setUploadFlags({ check: true });
                setValue("taxillaReportFile", response)
                await trigger("taxillaReportFile");
                toast.success('File Uploaded Successfully');
            })
        } else if (status === 'removed') {
            setUploadFlags({ check: false });
            setValue("taxillaReportFile", "");
        }
    }

    const handleBCReportFile = ({ meta, file }, status) => {
        if (status === 'done') {
            const formData = new FormData()
            formData.append('profile', file)
            Axios.put(`${process.env.REACT_APP_SERVER_URL}/api/users/uploadImage`, formData, {
            }).then(async (res) => {
                const response = res.data.msg;
                console.log("bc-report-response", response);
                setBCReportFile(response)
                setUploadFlags({ check: true });
                setValue("bcReportFile", response)
                await trigger("bcReportFile");
                toast.success('File Uploaded Successfully');
            })
        } else if (status === 'removed') {
            setUploadFlags({ check: false });
            setValue("bcReportFile", "");
        }
    }

    const handleSampleDownload = (type) => {
        let fileUrl, fileName;

        if (type === "TAXILLA") {
            fileUrl = "/sample_taxilla_upload.csv";
            fileName = "sample_taxilla_upload.csv";
        } else if (type === "BC") {
            fileUrl = "/sample_bc_upload.csv";
            fileName = "sample_bc_upload.csv";
        }
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
    }
    const handleGenerateReport = async (data) => {
        console.log("handleGenerateReport-data", data);
        setIsSubmitting(true);
        // Prepare the request payload      }
        const requestData = {
            startDate: data.startDate,
            endDate: data.endDate,
            taxillaReportFile: data.taxillaReportFile,
            BCReportFile: data.bcReportFile,
        };
        console.log("requestData", requestData);

        try {
            const res = await generateReconcileReport(requestData);
            console.log("generateReconcileReport-res", res);
            if (res.status === 200) {
                toast.success(res.data.result);
            }
            setIsSubmitting(false);
            reset();
            settaxillaReportFile('');
            setBCReportFile('');
            fetchReconcileReportLogs();
            setValue('');
        } catch (err) {
            setIsSubmitting(false);
        }
    }
    const handleDownload = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const downloadReport = async (report_id) => {
        try {
            console.log("downloadReport", report_id);

            const payload =
            {
                report_id: report_id

            }
            console.log("downloadReport payload:", payload)
            const res = await downloadReconciliationReport(payload);

            const result = res?.data?.result;
            console.log("downloadReport-res", result);
            handleDownload(result);
        } catch (err) {
            console.error("Error downloadReport:", err);
            toast.error("Failed to download report");
        }
    };

    const fetchReconcileReportLogs = async ({ status = selectedStatus, page = pagination.pageIndex + 1, limit = pagination.pageSize } = {}) => {
        try {
            console.log("fetchReconcileReportLogs");
            setLoading(true);

            const payload = {
                status,
                page,
                limit,
            };
            console.log("fetchReconcileReportLogs payload:", payload);
            const res = await getReconcileReportLogs(payload);

            const result = res?.data?.result;
            console.log("getReconcileReportLogs-res", result);
            setReportList(result?.data || []);
            setTotalPages(result?.pagination?.totalPages || 0);
            const totalCount = result?.pagination?.totalCount ?? (result?.pagination?.totalPages ? result.pagination.totalPages * limit : result?.data?.length ?? 0);
            setCount(totalCount);
        } catch (err) {
            console.error("Error fetching report logs:", err);
            toast.error("Failed to fetch report logs");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReconcileReportLogs({ status: selectedStatus, page: pagination.pageIndex + 1, limit: pagination.pageSize });
    }, [pagination.pageIndex, pagination.pageSize, selectedStatus]);


    return (

        <React.Fragment>
            <Breadcrumb parent="Reports" title="Reconcile Report" />

            <Container fluid>
                <Row>
                    <Col xl="12">
                        <Card>
                            <CardBody>
                                <Form justify-content-center onSubmit={handleSubmit(handleGenerateReport)}>

                                    {/* ================= Dates ================= */}
                                    <Row className="justify-content-center">
                                        <Col xs="12" md="6" lg="5">
                                            <FormGroup>
                                                <Label htmlFor="startDate">Start Date</Label>
                                                <Input
                                                    type="date"
                                                    id="startDate"
                                                    name="startDate"
                                                    innerRef={register({ required: true })}
                                                    onChange={() => setValue("endDate", "")}

                                                />
                                                {errors.startDate && (
                                                    <span className="text-danger">
                                                        Start date is required
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12" md="6" lg="5">
                                            <FormGroup>
                                                <Label htmlFor="endDate">End Date</Label>
                                                <Input
                                                    type="date"
                                                    id="endDate"
                                                    name="endDate"
                                                    innerRef={register({ required: true })}
                                                    min={watch("startDate")}
                                                    // max={getLastDayOfMonth(watch("startDate"))}
                                                    disabled={!watch("startDate")}
                                                    max={
                                                        watch("startDate")
                                                            ? (() => {
                                                                const start = new Date(watch("startDate"));
                                                                // Last day of the month
                                                                const lastDay = new Date(start.getFullYear(), start.getMonth() + 1, 0);

                                                                // Format to YYYY-MM-DD manually
                                                                const yyyy = lastDay.getFullYear();
                                                                const mm = String(lastDay.getMonth() + 1).padStart(2, "0");
                                                                const dd = String(lastDay.getDate()).padStart(2, "0");

                                                                return `${yyyy}-${mm}-${dd}`;
                                                            })()
                                                            : undefined
                                                    }
                                                />
                                                {errors.endDate && (
                                                    <span className="text-danger">
                                                        End date is required
                                                    </span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {/* ================= File Uploads ================= */}
                                    <Row className="justify-content-center">
                                        <Col xs="12" md="6" lg="5">
                                            <FormGroup>
                                                <Label>Taxilla File</Label>
                                                <Dropzone
                                                    name="taxilla_report"
                                                    onChangeStatus={handletaxillaReportFile}
                                                    maxFiles={1}
                                                    multiple={false}
                                                    canCancel={false}
                                                    inputContent="Upload File"
                                                    accept=".csv, .xlsx"
                                                    styles={{
                                                        dropzone: { width: "100%", minHeight: 60 },
                                                        dropzoneActive: { borderColor: "green" },
                                                        inputLabel: { fontSize: '15px' }
                                                    }}
                                                    {
                                                    ...register("taxillaReportFile", {
                                                        validate: () => uploadFlags.taxilla,
                                                    })
                                                    }
                                                />
                                                {errors.taxillaReportFile && (
                                                    <span className="text-danger">
                                                        Taxilla file is required
                                                    </span>
                                                )}
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <Button
                                                        color="info"
                                                        className="btn-square btn-xs"
                                                        style={{ borderRadius: "4px", padding: "5px 10px", fontSize: "11px" }}
                                                        onClick={() => handleSampleDownload("TAXILLA")}
                                                        type="button"
                                                    >
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        Taxilla Sample Format
                                                    </Button>
                                                </div>
                                            </FormGroup>

                                        </Col>
                                        <Col xs="12" md="6" lg="5">
                                            <FormGroup>
                                                <Label>BC Report File</Label>
                                                <Dropzone
                                                    name="bc_report"
                                                    onChangeStatus={handleBCReportFile}
                                                    maxFiles={1}
                                                    multiple={false}
                                                    canCancel={false}
                                                    inputContent="Upload File"
                                                    accept=".csv, .xlsx"
                                                    styles={{
                                                        dropzone: { width: "100%", minHeight: 60 },
                                                        dropzoneActive: { borderColor: "green" },
                                                        inputLabel: { fontSize: '15px' }
                                                    }}
                                                    {...register("bcReportFile", {
                                                        validate: () => uploadFlags.taxilla,
                                                    })}
                                                />
                                                {errors.bcReportFile && (
                                                    <span className="text-danger">
                                                        BC Report file is required
                                                    </span>
                                                )}
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <Button
                                                        color="info"
                                                        className="btn-square btn-xs"
                                                        style={{ borderRadius: "4px", padding: "5px 10px", fontSize: "11px" }}
                                                        onClick={() => handleSampleDownload("BC")}
                                                        type="button"
                                                    >
                                                        <i className="fa fa-download" aria-hidden="true"></i>
                                                        BC Sample Format
                                                    </Button>
                                                </div>
                                            </FormGroup>

                                        </Col>
                                    </Row>

                                    {/* ================= Action ================= */}
                                    <Row>
                                        <Col xs="12" md="4" className="mx-auto d-flex justify-content-center">
                                            <Button
                                                color="info"
                                                className="btn-gradient"
                                                type="submit"
                                                disabled={isSubmitting}
                                                style={{ minWidth: 100 }}
                                            >
                                                {isSubmitting ? "Loading..." : "Generate"}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>

                                {/* Status Selector */}
                                {/* <select
                                    value={selectedStatus}
                                    onChange={(e) => {
                                        setSelectedStatus(e.target.value);
                                    }}
                                >
                                    <option value="">All</option>
                                    <option value="SUCCESS">SUCCESS</option>
                                    <option value="FAILED">FAILED</option>
                                </select> */}
                                {/* ================= Generated Report Table ================= */}


                                {reportList.length > 0 && (
                                    <div className="mt-5">
                                        <MaterialReactTable
                                            columns={columns}
                                            data={reportList || []}

                                            enableColumnFilters={true}
                                            enableGlobalFilter={false}
                                            enableDensityToggle={false}


                                            manualFiltering
                                            onColumnFiltersChange={(updater) => {
                                                setColumnFilters((prev) => {
                                                    const nextFilters =
                                                        typeof updater === "function" ? updater(prev) : updater;

                                                    const statusFilter =
                                                        nextFilters.find((f) => f.id === "status")?.value || "";

                                                    setSelectedStatus(statusFilter);
                                                    setPagination((prev) => ({ ...prev, pageIndex: 0 }));

                                                    return nextFilters;
                                                });
                                            }}

                                            manualPagination
                                            rowCount={count}
                                            onPaginationChange={setPagination}
                                            state={{
                                                isLoading: loading,
                                                pagination,
                                                columnFilters,
                                            }}

                                            muiTableBodyProps={{
                                                sx: {
                                                    "& td": {
                                                        paddingTop: "8px",
                                                        paddingBottom: "8px",
                                                    },
                                                },
                                            }}

                                            positionToolbarAlertBanner="bottom"

                                            renderTopToolbarCustomActions={() => (
                                                <Box sx={{ fontSize: "16px", fontWeight: 600 }}>
                                                    Generated Reconcile Reports
                                                </Box>
                                            )}
                                        />
                                    </div>
                                )}

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container >

        </React.Fragment >
    )
}

export default ReconcileReport;